var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 23H37L34 19L31 23ZM31 27H37L34 31L31 27Z",
    fill: "#D6B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H20V37H14C13.7348 37 13.4804 36.8946 13.2929 36.7071C13.1054 36.5196 13 36.2652 13 36V14C13 13.7348 13.1054 13.4804 13.2929 13.2929C13.4804 13.1054 13.7348 13 14 13Z",
    fill: "#02897A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H28C28.2652 13 28.5196 13.1054 28.7071 13.2929C28.8946 13.4804 29 13.7348 29 14V36C29 36.2652 28.8946 36.5196 28.7071 36.7071C28.5196 36.8946 28.2652 37 28 37H22V13Z",
    fill: "#02897A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem1);
export default __webpack_public_path__ + "static/media/item1.3d8d80ce9f895ba2bc31c910783273da.svg";
export { ForwardRef as ReactComponent };